import successIcon from "@assets/images/competition/result/success.svg";
import errorIcon from "@assets/images/competition/result/error.svg";
import timeIcon from "@assets/images/competition/result/time.svg";

/** Yarışma menüsündeki sayfalar: backend CompetitionPageType → adres parçası ve varsayılan ad. */
export const PAGE_TYPES = {
  START: { slug: "", title: "Yarışma" },
  HOW_TO_PLAY: { slug: "nasil-yarisirim", title: "Nasıl Yarışırım?" },
  GIFTS: { slug: "hediyeler", title: "Hediyeler" },
  CORRECT_RESPONDERS: {
    slug: "dogru-yanitlayanlar",
    title: "Doğru Yanıtlayanlar",
  },
  WINNERS: { slug: "kazananlar", title: "Kazananlar" },
  RULES: { slug: "kurallar", title: "Yarışma Kuralları" },
  CORNER: { slug: "kose", title: "Yarışma Köşesi" },
};

export const pageTypeOfSlug = (slug) =>
  Object.keys(PAGE_TYPES).find(
    (type) => PAGE_TYPES[type].slug === (slug || "")
  ) || null;

/**
 * Sonuç ekranının başlığı ve admin metni boşsa gösterilecek yedek metin. Metinler
 * sonuç türüne göredir (backend PlayResultKind).
 */
/** Sonuç ikonları (Benim Bayim yarışma ekranlarından): başarı, hata, süre. */
export const RESULT_ICONS = {
  success: successIcon,
  error: errorIcon,
  time: timeIcon,
};

export const RESULT_DEFAULTS = {
  WON: {
    icon: "success",
    title: "Tebrikler!",
    tone: "success",
    message: "Soruyu doğru yanıtladınız ve sıralamaya göre hediye kazandınız.",
  },
  NO_REWARD: {
    icon: "success",
    title: "Doğru yanıt verdiniz",
    tone: "info",
    message:
      "Sıralamaya göre kazanan üyemiz olamadınız. Kazananlar ve doğru yanıtlayanlar listesi yarın yayınlanacak.",
  },
  CORRECT: {
    icon: "success",
    title: "Doğru yanıt verdiniz",
    tone: "info",
    message: "Kazananlar ve doğru yanıtlayanlar listesi yarın yayınlanacak.",
  },
  CORRECT_NEXT: {
    icon: "success",
    title: "Doğru yanıt!",
    tone: "success",
    message: "Günün sıradaki sorusuna geçebilirsiniz.",
  },
  WON_BEFORE: {
    icon: "success",
    title: "Değerli üyemiz",
    tone: "info",
    message:
      "Bu yarışmadaki hediye kazanma hakkınızı doldurdunuz. Hediyenizi iyi günlerde kullanmanızı dileriz.",
  },
  WRONG: {
    icon: "error",
    title: "Üzgünüz!",
    tone: "danger",
    message:
      "Yanlış yanıt verdiniz. Yarışmanın yeni sorusu yarın sizi bekliyor olacak.",
  },
  TIMEOUT: {
    icon: "time",
    title: "Üzgünüz!",
    tone: "danger",
    message:
      "Belirtilen süre içerisinde soruya yanıt veremediniz. Yarışmanın yeni sorusu yarın sizi bekliyor olacak.",
  },
};

export const CORNER_TEMPLATE_TITLES = {
  RAMADAN: "Ramazan Köşesi",
};

const TR_MONTHS = [
  "Ocak",
  "Şubat",
  "Mart",
  "Nisan",
  "Mayıs",
  "Haziran",
  "Temmuz",
  "Ağustos",
  "Eylül",
  "Ekim",
  "Kasım",
  "Aralık",
];
const TR_DAYS = [
  "Pazar",
  "Pazartesi",
  "Salı",
  "Çarşamba",
  "Perşembe",
  "Cuma",
  "Cumartesi",
];

/** "2026-03-01" → Date (yerel saatle gün başı). */
export const parseDate = (value) => {
  if (!value) return null;
  const [year, month, day] = String(value).slice(0, 10).split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const formatDate = (value) => {
  const date = parseDate(value);
  if (!date) return "-";
  return `${String(date.getDate()).padStart(2, "0")}.${String(date.getMonth() + 1).padStart(2, "0")}.${date.getFullYear()}`;
};

export const monthName = (date) => TR_MONTHS[date.getMonth()];
export const dayName = (date) => TR_DAYS[date.getDay()];

/** ISO tarih-saat → "10:00" (tarayıcı saatiyle). */
export const formatTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleTimeString("tr-TR", {
    hour: "2-digit",
    minute: "2-digit",
  });
};

// Sayının okunuşundaki son kelimeye göre bulunma eki: birler (1 bir … 9 dokuz) ve onlar (0 sıfır … 50 elli)
const UNIT_SUFFIX = ["", "de", "de", "te", "te", "te", "da", "de", "de", "da"];
const TEN_SUFFIX = ["da", "da", "de", "da", "ta", "de"];

/**
 * Saat, Türkçe bulunma ekiyle: "10:00'da", "11:00'de", "13:00'te", "09:45'te" (dakika varsa
 * dakikanın okunuşuna göre). Saat okunamazsa varsayılan saat kullanılır.
 */
export const timeWithSuffix = (value, fallback = "10:00") => {
  const time = formatTime(value) || fallback;
  const [hour, minute] = time.split(":").map(Number);
  const spoken = minute || hour;
  const suffix =
    spoken % 10
      ? UNIT_SUFFIX[spoken % 10]
      : TEN_SUFFIX[Math.floor(spoken / 10)];
  return `${time}'${suffix}`;
};

/** Bugünün yerel tarihi "YYYY-MM-DD". */
export const todayIso = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
};

export const errorMessage = (error, fallback) =>
  error?.message ||
  fallback ||
  "İşlem gerçekleştirilemedi. Lütfen tekrar deneyin.";
